import { Box, useMediaQuery, useTheme } from '@mui/material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  DialogActions,
} from '../../../common/components';
import GeneralDataSection from './GeneralDataSection';

const ProfileDialog = ({ open, onClose, editMode, selectedProfile, onInputChange, onSave }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const commonProps = {
    selectedProfile,
    onInputChange,
    isMobile,
    editMode,
  };

  return (
    <DialogContainer open={open} onClose={onClose} size="small">
      <DialogTitle>{editMode ? 'Editar perfil' : 'Agregar perfil'}</DialogTitle>

      <DialogBody sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 3 }}>
        <Box sx={{ flex: 1 }}>
          <GeneralDataSection {...commonProps} />
        </Box>
      </DialogBody>

      <DialogActions handleClose={onClose} handleSave={onSave} />
    </DialogContainer>
  );
};

export default ProfileDialog;
